export function getUsedFormProps(form) {
  const { portalId, guid, submitText, formFieldGroups, inlineMessage, redirect } = form || {};
  return { portalId, guid, submitText, formFieldGroups, inlineMessage, redirect };
}

export function valuesHaveField(values = {}, fieldName = '') {
  return Object.prototype.hasOwnProperty.call(values, fieldName);
}

export function handleFormRedirect(redirect, waitForSeconds = 3) {
  setTimeout(() => {
    window.location.href = redirect;
  }, waitForSeconds * 1000);
}
